import { render } from "./AreaFormModal.vue?vue&type=template&id=84d59a22"
import script from "./AreaFormModal.vue?vue&type=script&lang=js"
export * from "./AreaFormModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__